export const ERROR_CODE = {
  NO_EXIST: 'no_exist',
  NO_SESSION: 'no_session',
  NO_EXIST_RECORD: 'no_exit_record',
  PARKINGLOT_ERROR: 'parkinglot_error',
  PARKINGLOT_SETTING_ERROR: 'parkinglot_setting_error',
  FORM_VALIDATION_ERROR: 'form_validation_error',
  PAYMENT_ERROR: 'payment_error',
  NO_SIMILAR_LICENSE_PLATE: 'no_similar_license_plate',
  APS_DISABLED: 'aps_disabled',
};

export const errorMessage = (errorCode, errorContext) => {
  switch (errorCode) {
    case ERROR_CODE.NO_EXIST:
      return {
        title: '繳費機不存在',
        message: '請聯絡現場管理員並手動出場',
      };
    case ERROR_CODE.NO_EXIST_RECORD:
      return {
        title: '找不到停車紀錄',
        message: '請重新掃描並啟用停車線上繳費',
      };
    case ERROR_CODE.PARKINGLOT_ERROR:
      return {
        title: '停車場資訊設定錯誤',
        message: '請聯絡現場管理員並手動出場',
      };
    case ERROR_CODE.PARKINGLOT_SETTING_ERROR:
      return {
        title: '停車塲連線設定有誤',
        message: '請重新掃描，或聯絡現場管理員並手動出場',
      };
    case ERROR_CODE.PAYMENT_ERROR:
      return errorContext;
    case ERROR_CODE.NO_SESSION:
      return {
        title: '工作階段已過期',
        message: '請重新掃描並啟用停車線上繳費',
      };
    case ERROR_CODE.APS_DISABLED:
      return {
        title: '暫停支援',
        message: '本服務暫時停止支援，請以現場其他付款方式繳費離場',
      };
    default:
      return {
        title: '未預期錯誤',
        message: '發生未知錯誤，請重新嘗試。',
      };
  }
};

export const errorHandler = (error) => {
  if (typeof error === 'string' || error === null) return '';
  const { response } = error;
  if (response && response.status) {
    const { status, data } = response;
    switch (status) {
      case 400:
        return data.error;
      case 422:
        return Array.isArray(data.errors)
          ? data.errors[0].message
          : data.error?.message ?? data.message;
      case 500:
        return '伺服器發生錯誤';
      default:
        return error.message;
    }
  } else {
    return '伺服器發生未知錯誤';
  }
};

export const errorCodeHandler = (error) => {
  const { response } = error;
  if (response && response.status) {
    const { status, data } = response;
    if (status === 422) {
      return {
        type: 'http',
        status: 422,
        code: Array.isArray(data.errors)
          ? data.errors[0].code
          : data.error?.code ?? '',
      };
    } else {
      return { type: 'http', status, code: '' };
    }
  } else {
    return {
      type: 'unknown',
      code: '',
    };
  }
};
